import React, { useState } from "react";
import { AppBar, Box, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/system";
import { useBreakpoints } from "../hooks/useBreakpoint";

const sections = [
  { label: "ÚVOD", anchor: "uvod" },
  { label: "CENÍK", anchor: "cenik" },
  { label: "SLUŽBY", anchor: "sluzby" },
  { label: "GALERIE", anchor: "foto" },
  { label: "KONTAKT", anchor: "kontakt" },
];

const DarkAppBar = styled(AppBar)({
  background: "#2d2a22",
  boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
});

const scrollTo = (anchor: string) => {
  const el = document.getElementById(anchor);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Navbar: React.FC = () => {
  const { upMd } = useBreakpoints();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  return (
    <DarkAppBar position="sticky">
      <Toolbar>
        <img
          style={{ cursor: "pointer", height: "38px", width: "38px", borderRadius: "50%" }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          src="/assets/icons/logo.jpg"
          alt="logo"
        />
        <Typography
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          variant={upMd ? "h6" : "body1"}
          sx={{
            cursor: "pointer",
            color: "#d4c4a0",
            ml: 1.5,
            fontWeight: 700,
            letterSpacing: "2px",
            textTransform: "uppercase",
            flexGrow: 1,
          }}
        >
          STATEK VÍTEK
        </Typography>

        {upMd ? (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            {sections.map((s) => (
              <Box
                key={s.anchor}
                component="button"
                onClick={() => scrollTo(s.anchor)}
                sx={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#c0b090",
                  fontWeight: 700,
                  fontSize: "12px",
                  letterSpacing: "1.5px",
                  px: 1.5,
                  py: 0.75,
                  borderRadius: "4px",
                  transition: "background 0.15s, color 0.15s",
                  "&:hover": { background: "#c8b87a22", color: "#f5edd8" },
                }}
              >
                {s.label}
              </Box>
            ))}
          </Box>
        ) : (
          <>
            <IconButton onClick={(e) => setMenuAnchor(e.currentTarget)} sx={{ color: "#c0b090" }}>
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
              PaperProps={{ sx: { background: "#2d2a22" } }}
            >
              {sections.map((s) => (
                <MenuItem
                  key={s.anchor}
                  onClick={() => { scrollTo(s.anchor); setMenuAnchor(null); }}
                  sx={{ color: "#d4c4a0", "&:hover": { background: "#3a3628" } }}
                >
                  {s.label}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
      </Toolbar>
    </DarkAppBar>
  );
};

export default Navbar;
